import Constants from '@/Constants';
import { Questionnaire } from '@/models/Questionnaire';
import http from '@/services/HttpService';
import { AxiosResponse } from 'axios';
import { useSWRConfig } from 'swr';
import { useGet } from '../useGet';

interface QuestionnaireResponse {
    serverCurrentDate: number;
    data: Questionnaire;
}

const fetcher = (url: string) =>
    http.get(url).then(
        (response: AxiosResponse) =>
            ({
                serverCurrentDate: new Date(response.headers.currentdate).getTime(),
                data: response.data,
            } as QuestionnaireResponse),
    );

const getKey = (id?: number): string | null => {
    if (!id) {
        return null;
    }

    return `${Constants.EVALUATION_QUESTIONNAIRES_RESOURCE}/${id}`;
};

export const useQuestionnaire = (id?: number) => {
    const { cache } = useSWRConfig();

    const { data: response, revalidateResult, mutate: mutateQuestionnaire } = useGet<QuestionnaireResponse>(getKey(id), undefined, fetcher);

    const clear = (): void => {
        cache.delete(getKey(id));
    };

    const mutate = (questionnaire: Questionnaire, revalidate: boolean): void => {
        mutateQuestionnaire({ ...response, data: questionnaire } as QuestionnaireResponse, revalidate);
    };

    return { questionnaire: response?.data, serverCurrentDate: response?.serverCurrentDate, revalidateResult, mutate, clear };
};
